module.exports = {
  ME: 'spaceCatMeDesc',
  WE: 'spaceCatWeDesc',
  AMENITY: 'spaceCatAmenityDesc'
};
